import { render } from "./IssueArticleHeader.vue?vue&type=template&id=1a4f547e&scoped=true"
import script from "./IssueArticleHeader.vue?vue&type=script&lang=js"
export * from "./IssueArticleHeader.vue?vue&type=script&lang=js"

import "./IssueArticleHeader.vue?vue&type=style&index=0&id=1a4f547e&scoped=true&lang=css"

import exportComponent from "/Users/shanbhad/Documents/BitBucket/storyfinder2_ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4f547e"]])

export default __exports__